import React from 'react'
import widgetsService from 'live/services/widgets'
import EditorService from 'live/services/editor'

import i18n from 'live/services/i18n'
import { ANNOTATION_DEFAULT_CONFIG } from './utils/data'
import WidgetReducer from './widgetReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { withSuspenseWrapper } from '../../components/SuspenseWrapper'

const WrapperAnnotationsImpl = withSuspenseWrapper(React.lazy(() => import('./annotation')))
const WrapperEditorAnnotation = withSuspenseWrapper(React.lazy(() => import('./annotation-editor')))

export const REDUCER_LATEST = '@latest'

const policies = {
    legends: true,
    restrictViewModeOptionsHeight: true,
    allowHideTooltip: false,
    handleOwnMissingData: true,
    allowXAxisConfig: false,
    allowYAxisConfig: false
}

const widgetType = 'annotations'

const DEFAULT_CHART_CONFIG = {
    spanFinal: true,
    chartConfig: {
        ...ANNOTATION_DEFAULT_CONFIG
    }
}

widgetsService.impl(widgetType, reactWidgetWrapper(WrapperAnnotationsImpl, WidgetReducer))
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.config(widgetType, DEFAULT_CHART_CONFIG)
widgetsService.policies(widgetType, policies)

const KPIAnnotation = {
    label: 'Annotation Tool for KPIs',
    order: 18,
    type: `${widgetType}-editor`,
    description: i18n('Annotation Tool for Rigs and Well Performance'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: KPIAnnotation.type,
    editor: WrapperEditorAnnotation,
    defaultWidgetType: widgetType
})

EditorService.newEditorMenuOption(widgetType, KPIAnnotation)

widgetsService.editor(widgetType, KPIAnnotation.type)
widgetsService.ui(widgetType, { editor: KPIAnnotation.type })
